import "./datepicker.css";
import m from "mithril";

let datepicker = () => {
	let allowclear = false;

	let fpoptions = {
		altInput: true,
		defaultHour: 0,
		altFormat: "j M Y",
		enableTime: false,
		altInputClass: "",
		dateFormat: "Y-m-d",
	};
	let fptoptions = {
		altInput: true,
		defaultHour: 12,
		altFormat: "j M Y h:i K",
		enableTime: true,
		altInputClass: "",
		dateFormat: "Y-m-d H:i",
	};

	let fp = null;

	return {
		oncreate: (v) => {
			let options = v.attrs.options || {
				showtime: false,
				mode: null,
				OnUpdateEvent: () => {},
			};

			if (options.required) allowclear = false;
			else allowclear = true;

			let config = options.showtime ? fptoptions : fpoptions;
			config = {
				...config,
				minDate: options.minDate,
				maxDate: options.maxDate,
				defaultDate: options.defaultDate,
				onClose: (selectedDates, dateStr, instance) => {
					// console.log(selectedDates, dateStr, instance);
					options.OnUpdateEvent(dateStr);
				},
			};

			if (options.mode && options.mode == "range")
				config = {
					// altFormat: "j M Y",
					dateFormat: "Y-m-d",
					// dateFormat: "j M Y",
					mode: "range",
					onClose: (selectedDates, dateStr, instance) => {
						if (dateStr) {
							let dp = dateStr.split(" to ");
							if (dp && dp[0]) {
								let ed = null;
								if (dp[1]) ed = new Date(`${dp[1]}T00:00`);
								else ed = new Date(`${dp[0]}T00:00`);
								ed.setDate(ed.getDate() + 1);

								options.OnUpdateEvent(`>=${dp[0]} && <${moment(ed).format("YYYY-MM-DDTHH:mm:ssZZ").substr(0, 10)}`);
							}
						} else {
							options.OnUpdateEvent();
						}
					},
				};

			// console.log("final config", {config});
			fp = flatpickr(v.dom, config);
		},
		view: (v) => {
			return m("input.flatpickr.jscomponent", {
				class: v.attrs.options.disabled ? "disabled" : "",
				size: 1,
				value: v.attrs.options.value,
				readonly: true,
				...v.attrs.options,
			});
		},
		onremove: (v) => {
			fp.destroy();
		},
	};
};

export default datepicker;
